"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
function BookingLightbox(param) {
    var children = param.children, open = param.open, ctaCancel = param.ctaCancel, ctaForward = param.ctaForward, ctaForwardCall = param.ctaForwardCall, onClose = param.onClose;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Modal, {
        opened: open,
        onClose: onClose,
        withCloseButton: false,
        padding: 0,
        style: {
            width: "590px"
        },
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                style: {
                    textAlign: "center",
                    padding: " 0 2rem",
                    lineHeight: "2rem"
                },
                children: [
                    " ",
                    children
                ]
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                justify: "center",
                style: {
                    backgroundColor: "#F7F7F7",
                    padding: "20px",
                    borderTop: "1px solid #C8C9CA"
                },
                gap: 10,
                direction: {
                    base: "column",
                    lg: "row"
                },
                children: [
                    ctaCancel && ctaCancel.length && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                        onClick: onClose,
                        color: "dark",
                        variant: "outline",
                        styles: {
                            root: {
                                border: "solid",
                                backgroundColor: "transparent",
                                borderColor: "#000",
                                fontSize: "1em",
                                borderWidth: 2,
                                color: "#fff",
                                overflow: "visible",
                                textTransform: "uppercase"
                            },
                            label: {
                                color: "#000",
                                fontSize: "0.895em"
                            }
                        },
                        children: ctaCancel
                    }),
                    ctaForwardCall && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                        onClick: ctaForwardCall,
                        variant: "filled",
                        style: {
                            root: {
                                fontSize: "1em"
                            },
                            label: {
                                fontSize: "0.895em"
                            },
                            overflow: "visible",
                            textTransform: "uppercase"
                        },
                        children: ctaForward
                    })
                ]
            })
        ]
    });
}
var _default = BookingLightbox;
